import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { ReactComponent as RotateIcon } from '../../assets/icons/rotate-icon.svg';
import styles from './RotateScreen.module.scss';
import cn from 'classnames';
import Heading from '../Typography/Heading/Heading';
import { useTranslation } from 'react-i18next';
import Container from '../Container/Container';
import { useSelector } from 'react-redux';
import classNames from 'classnames';
const RotateScreen = () => {
    const { t } = useTranslation();
    const darkMode = useSelector((state) => state.settings.darkMode);
    return (_jsx("div", Object.assign({ className: cn('d-flex flex-column justify-content-center align-items-center', styles.element, darkMode && styles['isDarkMode']) }, { children: _jsxs(Container, Object.assign({ className: classNames('d-flex flex-column justify-content-center align-items-center', styles.wrapper) }, { children: [_jsx(RotateIcon, {}), _jsx(Heading, { className: styles.heading, title: t('rotate_your_phone').toLocaleUpperCase() })] })) })));
};
export default RotateScreen;
